const CARS_TEASER_DISMISS_KEY = 'theme:cars-teaser-dismissed';
const HOLD_MS = 3500;
const AWAY_MS = 5000;

class CarsMcqueenTeaser extends HTMLElement {
  connectedCallback() {
    if (this._ready) return;
    this._ready = true;

    if (sessionStorage.getItem(CARS_TEASER_DISMISS_KEY) === '1' && !this.hasAttribute('data-design-mode')) {
      this.remove();
      return;
    }

    this._rig = this.querySelector('.cars-teaser__rig');
    this._dismiss = this.querySelector('[data-cars-dismiss]');
    this._reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this._timers = [];
    this._stopped = false;

    const delay = Number(this.getAttribute('data-delay') || 0) * 1000;

    this._dismiss?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.dismiss();
    });

    this._onAnimEnd = (event) => this.onAnimationEnd(event);
    this._rig?.addEventListener('animationend', this._onAnimEnd);

    this._onPageShow = (event) => {
      if (!event.persisted || this._stopped) return;
      this._clearTimers();
      this.start();
    };
    window.addEventListener('pageshow', this._onPageShow);

    this._wait(delay, () => this.start());
  }

  _wait(ms, fn) {
    const id = window.setTimeout(fn, ms);
    this._timers.push(id);
    return id;
  }

  _clearTimers() {
    this._timers.forEach((id) => window.clearTimeout(id));
    this._timers = [];
  }

  onAnimationEnd(event) {
    if (event.target !== this._rig) return;
    if (event.animationName === 'cars-drive') this.park();
    if (event.animationName === 'cars-leave') this.afterLeave();
  }

  start() {
    if (this._stopped) return;
    this.hidden = false;
    if (this._reduceMotion) {
      this.park();
      return;
    }
    this.resetRig();
    this.classList.remove('is-parked', 'is-leaving');
    this.classList.add('is-driving');
  }

  park() {
    if (this._stopped) return;
    this.classList.remove('is-driving');
    this.classList.add('is-parked');
    if (this._reduceMotion) return;
    this._wait(HOLD_MS, () => this.leave());
  }

  leave() {
    if (this._stopped) return;
    this.classList.remove('is-parked', 'is-driving');
    this.classList.add('is-leaving');
  }

  afterLeave() {
    if (this._stopped) return;
    this.classList.remove('is-leaving');
    this.resetRig();
    this._wait(AWAY_MS, () => this.start());
  }

  resetRig() {
    if (!this._rig) return;
    this._rig.style.animation = 'none';
    this._rig.style.transform = 'translate3d(-120%, 10px, 0) rotate(-3deg)';
    this._rig.style.opacity = '1';
    void this._rig.offsetWidth;
    this._rig.style.animation = '';
    this._rig.style.transform = '';
  }

  dismiss() {
    this._stopped = true;
    this._clearTimers();
    sessionStorage.setItem(CARS_TEASER_DISMISS_KEY, '1');
    this.classList.remove('is-parked', 'is-driving');
    this.classList.add('is-leaving');

    const finish = () => this.remove();
    if (this._reduceMotion) {
      finish();
      return;
    }
    this._rig?.addEventListener('animationend', finish, { once: true });
    this._wait(1700, finish);
  }

  disconnectedCallback() {
    this._stopped = true;
    this._clearTimers();
    this._rig?.removeEventListener('animationend', this._onAnimEnd);
    window.removeEventListener('pageshow', this._onPageShow);
  }
}

if (!customElements.get('cars-mcqueen-teaser')) {
  customElements.define('cars-mcqueen-teaser', CarsMcqueenTeaser);
}
